import React, { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const DialogContext = createContext();

export const useDialog = () => useContext(DialogContext);

export const AppDialogProvider = ({ children }) => {
  const { t } = useTranslation();

  const [dialogState, setDialogState] = useState({
    open: false,
    title: "",
    message: "",
    severity: "info",
    onConfirm: null,
  });

  const showDialog = ({ title, message, severity = "info", onConfirm }) => {
    setDialogState({ open: true, title, message, severity, onConfirm });
  };

  const closeDialog = () => {
    setDialogState((prev) => ({ ...prev, open: false }));
  };

  const handleConfirm = () => {
    if (dialogState.onConfirm) dialogState.onConfirm();
    closeDialog();
  };

  return (
    <DialogContext.Provider value={{ showDialog }}>
      {children}

      <Dialog open={dialogState.open} onClose={closeDialog}>
        <DialogTitle sx={{ fontWeight: "bold" }}>
          {dialogState.title}
        </DialogTitle>
        <DialogContent>
          <Alert
            severity={dialogState.severity}
            sx={{ mb: 2, fontSize: "1.2rem" }}
          >
            {dialogState.message}
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} sx={{ fontWeight: "bold" }}>
            {t("cancel")}
          </Button>
          {dialogState.onConfirm && (
            <Button
              variant="contained"
              sx={{ fontWeight: "bold" }}
              onClick={handleConfirm}
            >
              {t("confirm")}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </DialogContext.Provider>
  );
};
